export enum InputType {
  QUANTITY = 'quantity',
  ENUM = 'enum',
  PERIOD = 'period',
  MULTISELECT = 'multiselect',
}

export enum FieldType {
  QUANTITY = 'quantity',
  DATETIME = 'date-time',
  BOOLEAN = 'boolean',
}
